import { render, staticRenderFns } from "./my-organisation-competencies.vue?vue&type=template&id=41be3080&"
import script from "./my-organisation-competencies.vue?vue&type=script&lang=js&"
export * from "./my-organisation-competencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/my-organisation-competencies.vue
// module id = 1709
// module chunks = 0